// extracted by mini-css-extract-plugin
module.exports = {"root":"Radiobutton_root__2IM-V","disabled":"Radiobutton_disabled__15ZPJ","label":"Radiobutton_label__3JlsS"};